import { TaxReasonNoTIN } from '~/types'

export const ReasonsForNotProvidingTINOptions = new Map<string, string>([
  [TaxReasonNoTIN.NOT_ISSUED, 'A - TIN Not Issued (The Country does not issue TINs)'],
  [TaxReasonNoTIN.NOT_REQUIRED, 'B - TIN Not Required (The Country does not require collection of a TIN)'],
  [TaxReasonNoTIN.APPLIED_FOR, 'C - TIN Applied For (I have applied for a TIN and will inform you upon receipt)'],
  [TaxReasonNoTIN.UNOBTAINABLE, 'Z - TIN Unobtainable (I am unable to obtain a TIN)']
])
